import React from 'react'
import { useTranslation } from 'react-i18next'
import { formatNumber, formatPhoneNumber } from '../../../utils/formatNumber'
import DateTimeText from '../../ui/DateTimeText'
import { Customer } from '../../../types/modules/admin/customer.type'
import { Link } from 'react-router-dom'
import { CustomerStatus } from '../../../types/enum/customerStatus'

type Props ={
    customer:Customer
}

function CustomerItem({customer}:Props) {
        const {t} = useTranslation();
  return (
    <>
        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {formatNumber(customer.id)}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {customer.name}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {formatPhoneNumber(customer.phone??"")}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {(customer.email)}
        </td>

        <td className={`p-3 min-w-[200px] text-Black font-normal text-justify capitalize ${customer.status===CustomerStatus.SUSPENDED?"text-Red":"text-primaryButton"}`}>
            {t(customer.status)}
        </td>

        <td className="p-3 min-w-[300px] text-Black font-normal text-justify">
            <DateTimeText date={customer.createdAt}/>
        </td>

        <td className="p-3 min-w-[300px] text-Black font-normal text-justify">
            <DateTimeText date={customer.lastLoginAt??""}/>
        </td>

        <td className="p-3 min-w-[300px] text-Black font-normal text-justify">
            <DateTimeText date={customer.lastActive??""}/>
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            <Link to={`${customer.id}`} className=' capitalize underline'>
            {t('view')}
            </Link>
        </td>        
    </>
  )
}

export default CustomerItem